"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersAndRenewalsDto = exports.MembershipPauseResponeDto = exports.GetPauseHistoryQuery = exports.PauseHistoryDto = exports.GetPauseByIdResponseDto = exports.UpdatePauseMembershipMemberDto = exports.UnPauseMembershipMemberDto = exports.PauseMembershipMemberDto = exports.GetPauseOptionsDto = exports.ByCustomerAndMemberParamsDto = exports.ByMemberAndMemberParamsDto = exports.DurationDto = exports.MembershipMemberRenewalDto = void 0;
const organization_dto_1 = require("../../organization/dto/organization.dto");
const general_dto_1 = require("../../dto/general.dto");
class MembershipMemberRenewalDto {
}
exports.MembershipMemberRenewalDto = MembershipMemberRenewalDto;
class DurationDto {
}
exports.DurationDto = DurationDto;
class ByMemberAndMemberParamsDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByMemberAndMemberParamsDto = ByMemberAndMemberParamsDto;
class ByCustomerAndMemberParamsDto extends ByMemberAndMemberParamsDto {
}
exports.ByCustomerAndMemberParamsDto = ByCustomerAndMemberParamsDto;
class GetPauseOptionsDto {
}
exports.GetPauseOptionsDto = GetPauseOptionsDto;
class PauseMembershipMemberDto {
}
exports.PauseMembershipMemberDto = PauseMembershipMemberDto;
class UnPauseMembershipMemberDto {
}
exports.UnPauseMembershipMemberDto = UnPauseMembershipMemberDto;
class UpdatePauseMembershipMemberDto {
}
exports.UpdatePauseMembershipMemberDto = UpdatePauseMembershipMemberDto;
class GetPauseByIdResponseDto {
}
exports.GetPauseByIdResponseDto = GetPauseByIdResponseDto;
class PauseHistoryDto {
}
exports.PauseHistoryDto = PauseHistoryDto;
class GetPauseHistoryQuery extends general_dto_1.PaginationQuery {
}
exports.GetPauseHistoryQuery = GetPauseHistoryQuery;
class MembershipPauseResponeDto {
}
exports.MembershipPauseResponeDto = MembershipPauseResponeDto;
class MembersAndRenewalsDto {
}
exports.MembersAndRenewalsDto = MembersAndRenewalsDto;
//# sourceMappingURL=membershipMember.dto.js.map